import React, { useState } from "react";
import { Blacked, ModalContent, ModalHeader, ModalInput, ModalSubmit, ModalTitle, ModalWrapper } from "../styles";
import { Icon } from "CRM/organism/Main/styles";
import { FaChevronLeft } from "react-icons/fa6";
import { Input, message } from "antd";
import API from "utils/api";
import { useToken } from "app/hooks";
import { useBranchList } from "CRM/hooks/GetBranchList";
import { useIsMobile } from "../IsMobile";

export const ImageModal = ({ imagePath, setImagePath }) => {
	const IsMobile = useIsMobile();

	return (
		<>
			<Blacked onClick={() => setImagePath(null)} />
			<ModalWrapper IsMobile={IsMobile}>
				{/*<ModalHeader>*/}
				{/*  <Icon onClick={() => setIsEdit(false)}><FaChevronLeft /></Icon>*/}
				{/*  <ModalTitle>지사 수정</ModalTitle>*/}
				{/*  <ModalSubmit onClick={clickSubmit}>저장</ModalSubmit>*/}
				{/*</ModalHeader>*/}
				<ModalContent>
					<img
						src={process.env.REACT_APP_API_URL + imagePath}
						style={{ width: "100%" }}
					/>
				</ModalContent>
			</ModalWrapper>
		</>
	);
};
